import { useEffect, useState } from 'react';

type ScreenSize = {
  width: number;
  height: number;
  isInitialSize: boolean;
};

const useScreenSize = () => {
  const [screenSize, setScreenSize] = useState<ScreenSize>({
    width: window.innerWidth,
    height: window.innerHeight,
    isInitialSize: true,
  });
  useEffect(() => {
    const handleResize = () => {
      setScreenSize({
        width: window.innerWidth,
        height: window.innerHeight,
        isInitialSize: false,
      });
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  return screenSize;
};

export default useScreenSize;
